import styles from "./Input.module.css";

const InputHeader = ({ text, required }) => {
  return required ? (
    <p className={styles.inputHeader}>
      {text}
      <span className={styles.required}>*</span>
    </p>
  ) : (
    <p className={styles.inputHeader}>{text}</p>
  );
};

export default InputHeader;
